import { isPlatformServer } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { sleep } from 'src/app/lib/sleep';
import { throttle } from 'src/app/lib/throttle';

@Component({
  selector: 'app-sticky',
  templateUrl: './sticky.component.html',
  styleUrls: ['./sticky.component.scss'],
  standalone: true,
})
export class StickyComponent implements OnInit {
  @ViewChild('element') element: ElementRef;
  @Input() container: HTMLElement;
  @Input() paddingX = 0;
  @Input() paddingY = 0;
  @Input() offsetY = 0;
  @Input() minHeight = 0;
  @Input() zIndex = 49;
  @Input() extraYSpacing = 0;
  @Input() autoFill: HTMLElement;
  @Input() fullWidth: boolean;
  fixed: boolean;
  atBottom: boolean;
  height: number;

  @HostListener('window:scroll')
  onScroll() {
    this.calcThrottled();
  }
  constructor(@Inject(PLATFORM_ID) private platformId: string) {}

  async ngOnInit() {
    await sleep(1);
    this.calcThrottled();
  }

  calcThrottled = throttle(() => {
    this.calc();
  }, 16);

  calc() {
    if (isPlatformServer(this.platformId)) return;
    const bounds = this.container?.getBoundingClientRect();
    if (!bounds) return;

    const top = -bounds.top + this.offsetY + this.paddingY;
    const elHeight = this.element ? this.element.nativeElement.getBoundingClientRect().height : 0;
    const containerHeight = bounds.height - elHeight;
    this.atBottom = top > containerHeight - this.paddingY;

    const _top = -bounds.top + this.offsetY;
    if (_top < 0) this.fixed = false;
    else this.fixed = !this.atBottom;

    if (this.autoFill) {
      const autoFillBounds = this.autoFill.getBoundingClientRect();
      const bottom = window.innerHeight - autoFillBounds.bottom + this.extraYSpacing;
      const top = autoFillBounds.top - this.offsetY + this.extraYSpacing;

      let height = autoFillBounds.height - this.paddingY * 2 - this.extraYSpacing * 2;
      if (bottom < 0) height += bottom;
      if (top < 0) height += top;

      if (height < this.minHeight) height = this.minHeight;

      this.height = height;
    }
  }
}
